export interface CompanyDeal {
  securityType: string;
  marketStatus: string;
  meetingDate?: string;
  dealType?: string;
  booksClosed?: string;
  size: string;
  uop?: string;
}

export enum DealSecurityType {
  Bond = 'bond',
  Loan = 'loan',
}

export enum ModerationStatus {
  DRAFT = 'draft',
  HOLD = 'hold',
  PUBLISHED = 'published',
  REMOVE = 'remove',
  SENT = 'sent',
  UNPUBLISHED = 'unpublished',
}
